import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  Category,
  Subscriptions,
  LocalShipping,
} from '@mui/icons-material';
import PipelineKPICards from '../components/Pipeline/PipelineKPICards';
import ProgramsTable from '../components/Pipeline/ProgramsTable';
import SubscriptionsTable from '../components/Pipeline/SubscriptionsTable';
import DeliveriesTable from '../components/Pipeline/DeliveriesTable';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`pipeline-tabpanel-${index}`}
      aria-labelledby={`pipeline-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `pipeline-tab-${index}`,
    'aria-controls': `pipeline-tabpanel-${index}`,
  };
}

const PipelineManagementPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  const handleKPICardClick = (cardType: 'mrr' | 'subscriptions' | 'avg-value' | 'leads') => {
    switch (cardType) {
      case 'subscriptions':
        setCurrentTab(1); // Navigate to Subscriptions tab
        break;
      case 'leads':
        setCurrentTab(2); // Navigate to Deliveries tab
        break;
      default:
        break;
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Pipeline Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage service offerings, track subscriptions, and monitor lead deliveries
        </Typography>
      </Box>

      {/* KPI Cards */}
      <Box sx={{ mb: 4 }}>
        <PipelineKPICards onCardClick={handleKPICardClick} />
      </Box>

      {/* Tabs Navigation */}
      <Paper sx={{ mt: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<Category />} label="Programs" />
          <Tab icon={<Subscriptions />} label="Subscriptions" />
          <Tab icon={<LocalShipping />} label="Lead Deliveries" />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <ProgramsTable />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <SubscriptionsTable />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <DeliveriesTable />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default PipelineManagementPage;
